// src/router/index.js
import WelcomeView from "@/views/WelcomeView.vue";
import { createRouter as createVueRouter, createWebHashHistory } from "vue-router";
// Import createAuthGuard conditionally if needed
// import { createAuthGuard } from "@auth0/auth0-vue";
import CustomLoginView from "@/views/CustomLoginView.vue"; // Import the custom login view

console.log("[Router] VUE_APP_AUTH0_ENABLED:", process.env.VUE_APP_AUTH0_ENABLED);
const isAuth0Enabled = process.env.VUE_APP_AUTH0_ENABLED !== 'false';
console.log("[Router] isAuth0Enabled:", isAuth0Enabled);

export function createRouter() {
  const routes = [
    {
      path: "/",
      name: "WelcomePage",
      component: WelcomeView,
      // Conditional guard
    },
    {
      path: '/login',
      name: "LoginPage",
      // Conditional component
    },
    {
      path: "/tradition",
      name: "tradition",
      component: () => import("@/views/TraditionView.vue"),
      redirect: '/tradition/edit', // Redirect to default child
      // Conditional guard
      children: [
        {
          path: "edit",
          name: "tradition-edit",
          component: () => import("@/components/tradition/TraditionEditView.vue"),
        },
        {
          path: "analysis/:resultId?",
          name: "tradition-analysis",
          component: () => import("@/components/tradition/TraditionAnalysisView.vue"),
        },
      ],
    },
    {
      path: "/urban",
      name: "urban",
      component: () => import("@/views/UrbanView.vue"),
      redirect: '/urban/edit',
      // Conditional guard
      children: [
        {
          path: "edit",
          name: "urban-edit",
          component: () => import("@/components/urban/UrbanEditView.vue"),
        },
        {
          path: "analysis/:resultId?",
          name: "urban-analysis",
          component: () => import("@/components/urban/UrbanAnalysisView.vue"),
        },
      ],
    },
    {
      path: "/train",
      name: "train",
      component: () => import("@/views/TrainView.vue"),
      // Conditional guard
    },
  ];

  if (isAuth0Enabled) {
    // Dynamically import createAuthGuard only when Auth0 is enabled
    return import('@auth0/auth0-vue').then(({ createAuthGuard }) => {
      routes.forEach(route => {
        if (route.name === 'WelcomePage' || route.name === 'tradition' || route.name === 'urban' || route.name === 'train') {
          route.beforeEnter = createAuthGuard();
        }
        if (route.name === 'LoginPage') {
          route.component = () => import("@/views/LoginPage.vue");
        }
      });
      return createVueRouter({
        routes,
        history: createWebHashHistory(),
      });
    }).catch(error => {
      console.error("Failed to load createAuthGuard for router:", error);
      // Fallback router configuration if Auth0 module fails
      routes.forEach(route => {
        if (route.name === 'LoginPage') {
          route.component = CustomLoginView; // Fallback to custom login if Auth0 guard fails to load
        }
      });
      return createVueRouter({
        routes,
        history: createWebHashHistory(),
      });
    });
  } else {
    // Auth0 is disabled, configure routes without Auth0 guards and use CustomLoginView
    console.log("[Router] Auth0 is DISABLED. Configuring routes for custom login.");
    routes.forEach(route => {
      if (route.name === 'LoginPage') {
        route.component = CustomLoginView;
        console.log("[Router] LoginPage component set to CustomLoginView");
      }
      delete route.beforeEnter;
    });

    const router = createVueRouter({
      routes,
      history: createWebHashHistory(),
    });

    router.beforeEach((to, from, next) => {
      const customUserLoggedIn = localStorage.getItem('customUserLoggedIn') === 'true';
      console.log("[Router Guard] Auth0 Disabled - customUserLoggedIn:", customUserLoggedIn, "Target route:", to.name, "From route:", from.name);

      if (to.name === 'WelcomePage' && !customUserLoggedIn) {
        console.log("[Router Guard] Auth0 Disabled - Redirecting to LoginPage from WelcomePage because user is not logged in.");
        next({ name: 'LoginPage' });
      } else if (to.name === 'LoginPage' && customUserLoggedIn) {
        // Optional: If user is already logged in via custom method and tries to access LoginPage, redirect them to WelcomePage
        console.log("[Router Guard] Auth0 Disabled - User is already logged in, redirecting from LoginPage to WelcomePage.");
        next({ name: 'WelcomePage' });
      } else {
        next();
      }
    });

    return router;
  }
}
